import {ImageIcon} from '@/components/svg/ImageIcon';
import {AttachmentIcon, CloseIcon} from '@chakra-ui/icons';
import {Box, HStack, IconButton, Text} from '@chakra-ui/react';
import {useTranslation} from 'react-i18next';
import {formatFileSize} from '../PdfOrderImport/utils';

/**
 * Preview des fichiers sélectionnés avant envoi d'un message.
 * Affiche le nom, la taille et une icône selon le type de fichier.
 */
export const ConversationFichiersPreview: React.FC<{
  selectedFiles: File[];
  onRemoveFile: (index: number) => void;
}> = ({selectedFiles, onRemoveFile}) => {
  const {t} = useTranslation();

  if (selectedFiles.length === 0) {
    return null;
  }

  return (
    <Box mb={2}>
      {selectedFiles.map((file, index) => (
        <HStack
          key={`${file.name}-${index}`}
          bg='white'
          p={2}
          mb={1}
          borderRadius='8px'
          justify='space-between'
        >
          <HStack spacing={2}>
            {file.type.startsWith('image/') ? (
              <ImageIcon color='gray.dark' />
            ) : (
              <AttachmentIcon color='gray.dark' />
            )}
            <Text
              fontSize='sm'
              color='gray.dark'
              noOfLines={1}
            >
              {file.name}
            </Text>
            <Text
              fontSize='xs'
              color='gray.dark'
            >
              ({formatFileSize(file.size, t)})
            </Text>
          </HStack>
          <IconButton
            aria-label={t('global.supprimer')}
            icon={<CloseIcon boxSize={3} />}
            size='xs'
            variant='ghost'
            color='gray.dark'
            onClick={() => {
              onRemoveFile(index);
            }}
          />
        </HStack>
      ))}
    </Box>
  );
};
